<template>
  <base-container style="height: 100%" :isLoading="loading">
    <el-form
      style="margin-top: 10px"
      label-position="right"
      label-width="100px"
      :model="formData"
      size="mini"
      ref="ruleForm"
    >
      <el-form-item label="排班星期" prop="weekNo">
        <el-radio-group disabled v-model="formData.weekNo">
          <el-radio-button
            v-for="week in weeks"
            :key="week.weekNo"
            :label="week.weekNo"
          >
            {{ week.name }}
          </el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="排班时段">
        <el-time-select
          disabled
          placeholder="起始时间"
          v-model="formData.startPoint"
          :picker-options="{
            start: '00:00',
            step: '00:30',
            end: '24:00',
          }"
        >
        </el-time-select>
        <span class="margin-h10">-</span>
        <el-time-select
          disabled
          placeholder="结束时间"
          v-model="formData.endPoint"
          :picker-options="{
            start: '00:00',
            step: '00:30',
            end: '24:00',
            minTime: formData.startTime,
          }"
        >
        </el-time-select>
      </el-form-item>
      <el-form-item label="就诊类型" prop="clinicType">
        <el-radio-group size="mini" v-model="formData.clinicType">
          <el-radio-button label="">不限</el-radio-button>
          <el-radio-button label="outpatient">门诊</el-radio-button>
          <el-radio-button label="inpatient">住院</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="时段号源数">
        <el-input-number
          style="width: auto"
          :min="0"
          size="mini"
          :controls="false"
          v-model="formData.totalCount"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="预留号源数">
        <el-input-number
          style="width: auto"
          :min="0"
          size="mini"
          :controls="false"
          v-model="formData.saveCount"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="签到时间">
        <el-time-select
          placeholder="起始时间"
          v-model="formData.signStart"
          :picker-options="{
            start: '00:00',
            step: '00:30',
            end: '24:00',
          }"
        >
        </el-time-select>
        <span class="margin-h10">-</span>
        <el-time-select
          placeholder="结束时间"
          v-model="formData.signEnd"
          :picker-options="{
            start: '00:00',
            step: '00:30',
            end: '24:00',
            minTime: formData.signStart,
          }"
        >
        </el-time-select>
      </el-form-item>
      <el-form-item label="授权渠道">
        <el-select multiple collapse-tags size="mini" v-model="formData.appIds">
          <el-option
            :label="app.label"
            v-for="app in appList"
            :key="app.value"
            :value="app.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </base-container>
</template>

<script>
import Config from "@/config/constant";
import { loadEnum } from "@/api/sys/dicType";
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          weekNo: "",
          startPoint: "",
          endPoint: "",
          clinicType: "",
          totalCount: 0,
          saveCount: 0,
          signStart: "",
          signEnd: "",
          ruleIds: [],
          appIds: [],
        };
      },
    },
  },
  data() {
    const formData = Object.assign({}, this.data);
    return {
      loading: false,
      weeks: Config.weeks,
      appList: [],
      formData,
    };
  },
  created() {
    loadEnum("SysAppInfo").then((res) => {
      this.appList = res.data.data;
    });
  },
  methods: {
    getData() {
      return this.formData;
    },
  },
};
</script>

<style></style>
